(function ($, Global) {

    var access;
    var audit;

    function PooolPaywallComponent() {   
        // Déclaration class objet
    }

    PooolPaywallComponent.prototype.initEvents = function () {
        if (Global.Access == null) {
            return this.Paywall_RollbackToIndigPaywall('no Global.Access');
        }
        try {
            access = Global.Access.init(Global.PAYWALL_TAG_ID).config({ cookies_enabled: true });
            audit = Global.Audit.init(Global.PAYWALL_TAG_ID).config({ cookies_enabled: true });
            if (access == undefined || audit == undefined) return this.Paywall_RollbackToIndigPaywall('no access or audit');
            this.publishers();
            this.configAndCreate(audit, access);
        } catch (err) {
            this.Paywall_RollbackToIndigPaywall('Poool catch error');
        }       

    }
	PooolPaywallComponent.prototype.configAndCreate = function (audit, access) {
		audit.sendEvent('page-view', { type: (Global.PAYWALL_PREMIUM_CONTENT == 'true' || Global.PAYWALL_CONTEXT != "non-identifie") ? 'premium' : 'free' });
		access.config('cookies_domain', Global.location.hostname);
        access.config('locale', Global.LANG == 'Francais' ? 'fr' : 'en');

		if (Global.PAYWALL_CONTEXT != 'non-identifie' || Global.PAYWALL_USER_SEGMENT == 'article-non-achetable') {
			access.config('context', Global.PAYWALL_CONTEXT);
			audit.config('context', Global.PAYWALL_CONTEXT);
			if (Global.PAYWALL_USER_SEGMENT != '') {
				access.config('custom_segment', Global.PAYWALL_USER_SEGMENT);
				audit.config('custom_segment', Global.PAYWALL_USER_SEGMENT);
			}

            if (Global.PAYWALL_USER_STATUS == '5') access.config('user_is_premium', true);
		}
        access.config('custom_reader_id', Global.PAYWALL_USR_ID);


		access.variables({
			'utilisateur_type': Global.PAYWALL_USER_STATUS,
			'utilisateur_solde': Global.PAYWALL_USER_SOLDE,
			'contenu_prix': Global.PAYWALL_ITEM_PRICE,
			'date_fin': Global.PAYWALL_ABO_DATEFIN,
			'contenu_monnaie': Global.PAYWALL_ITEM_CURRENCY,
			'contenu_type': Global.PAYWALL_ITEM_TYPE,
            'utilisateur_id': Global.PAYWALL_USR_ID,
			'utilisateur_email': Global.PAYWALL_USER_EMAIL,
            'description_format': Global.PAYWALL_ARTICLE_DESCRIPTION_FORMAT,
            'description_solde': Global.PAYWALL_USER_SOLDE_DESCRIPTION,
            'etat_abo': Global.PAYWALL_USER_ETAT_ABO,
            'texte_etat_abo': Global.PAYWALL_USER_TEXTE_ETAT_ABO,
            'credit_restant_apres_achat': Global.PAYWALL_USER_SOLDE_AFTER_BUY
		});

		access.texts('unlocked', Global.LANG == 'Francais' ? 'formulaire envoyé' : 'form submitted');
	
		access.createPaywall({
			target: '#poool-widget',
			mode: 'custom',
			pageType: (Global.PAYWALL_PREMIUM_CONTENT == 'true') ? 'premium' : 'free'
		});
	}

    PooolPaywallComponent.prototype.publishers = function () {
        var self = this;

        Global.PAYWALL_TRIGGER = null;
        Global.PAYWALL_TRIGGER_TYPE = null;
        Global.PAYWALL_TRIGGER_VALUE = null;

        access.on('ready', function (event) {
            Global.dataLayer.push({
                event: "pooolReady",
                paywallType: event.widget
            });
        });

        access.once('release', function (event) {
            $('#poool-widget').attr('style','min-height:500px;').empty();
            $.Topic('loader-show').publish('#poool-widget');
            var apiUrl = '/ajax/articles/paywallcheckrelease?idArticle=' + Global.PAYWALL_ARTICLE_ID;
            $.ajaxGet(apiUrl, null)
                .done(function (result) {
                    if (result.isSuccess) {
                        if (event.actionName == 'dernier article offert avec offre') {
                            //TODO APPEL AJOUT UTILISATEUR OFFRE
                        }
                        location.reload();
                    }
                    else {
                        // Handle specific error cases
                        if (result.feedback && result.feedback.includes("POOOL_RELOAD_REQUIRED")) {
                            if (Global.Sentry != undefined) {
                                Global.Sentry.captureMessage('Poool paywall refresh required: Consumed missmatch');
                            }
                            // Force reload for consumed missmatch errors to reset state
                            console.log('Forcing page reload due to consumed missmatch');
                            location.reload();
                        } else {
                            // For other errors, reload the page to ensure the paywall is displayed correctly
                            location.reload();
                        }
                    }
                   
                })
                .fail(function (xhr, status, error) {
                    // Handle AJAX failures
                    if (Global.Sentry != undefined) {
                        Global.Sentry.captureException('Poool paywall API error', {
                            extra: {
                                status: status,
                                error: error
                            }
                        });
                    }
                    location.reload();
                });
        });

        access.once('identityAvailable', function (event) {
            Global.PAYWALL_SCENARIO = event.scenarioName;
            Global.PAYWALL_USER_SEGMENT = event.segment_slug;
            Global.PAYWALL_POOLUSERID = event.user_id;
            Global.PAYWALL_POOLCONTEXTID = event.contextName;
            Global.PAYWALL_TRIGGER = event.trigger;
            Global.PAYWALL_TRIGGER_TYPE = event.triggerType;
            Global.PAYWALL_TRIGGER_VALUE = event.triggerValue;
        });

        var eventNames = ['paywallSeen', 'release', 'subscribeClick', 'alternativeClick', 'discoveryLinkClick']

        eventNames.forEach(function(eventName) {
            access.on(eventName, function (event) {
                self.pushDataLayer(eventName, event.widget, event.actionName)
            });
        }) 

        access.once('formSubmit', function (event) {
            if (!['creation-compte-nom-prenom', 'register-free', 'newsletter',
                'creation-compte-nom-acces-libre', 'creation-compte-acces-libre',
                'creation-compte-nom-premium', 'creation-compte-premium',
                'newsletter-premium',].includes(event.name)) return
            var invalid = self.Paywall_ValidateForm(event);
            if (invalid.length > 0) return invalid;

            $.Topic('loader-show').publish('#poool-widget');

            self.pushDataLayer("FormSubmit_" + event.name, '', '')

            if (event.name == 'newsletter' || event.name == 'newsletter-premium') {
                self.subscribeNewsletter(event);
                return;
            }
            var prefix = '';

            var localPathName = Global.location.pathname.toLowerCase();
            if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
            if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

            self.register(event)
                .then(function (result) {
                    $.Topic('loader-hide').publish('#poool-widget');
                    if (result.errors && result.errors.Identifiant) {
                        invalid.push({ fieldKey: 'email', message: result.errors.Identifiant });
                        return invalid;
                    }
                    Global.ajaxCallback({
                        results: result,
                        success: function () {
                            Global.location.replace(prefix+'/SignUp/EmailValidationRequired?confirm');
                        }
                    })
                });
        })

        access.once('loginClick', function (event) {
            event.originalEvent.preventDefault();
            self.pushDataLayer('loginClick', '', event.actionName)
            $.Topic('signin-modal-show').publish('simple');
        })

        access.on('customButtonClick', function (event) {
            var libelle = event.name ? event.name : event.buttonId;
            self.pushDataLayer('customButtonClick_' + libelle, '', event.actionName)
            return self.Paywall_HandleButtonClick(event.name);
        })

        access.on('error', function (error, event) {
            // Log detailed error information to console and Sentry
            console.error('Poool access error:', error);
            
            if (Global.Sentry != undefined) {
                Global.Sentry.captureException(error, {
                    extra: {
                        event: event
                    }
                });
            }
            return self.Paywall_RollbackToIndigPaywall('Poool access, on error');
        });
    }

    PooolPaywallComponent.prototype.register = function (event) {
        var formData = {
            Nom: event.fields.name,
            Prenom: event.fields.firstname,
            Identifiant: event.fields.email,
            MotDePasse: event.fields.password,
            MotDePasseConfirmation: event.fields.passwordValidation,
            Redirect: Global.PAYWALL_USER_REDIRECT,
            IdArticle: Global.PAYWALL_ARTICLE_ID,
            TypeCreationCompte: "Prospect",
            UrlCreation: Global.PAYWALL_URL_CREATION,
            CategoriePage: $('meta[name="CategoryPage"]').attr('content')
        };

        return $.ajaxPost('/ajax/login/create', formData)
            .done(function(result) {
                return result;
            });
    }

    PooolPaywallComponent.prototype.Paywall_RollbackToIndigPaywall = function (reason) {

        //Fire a sentry error
        if (reason && Global.Sentry!=undefined) {
            Global.Sentry.captureException(new Error('Poool paywall fallback: ' + reason));
        }
        else if (Global.Sentry != undefined) {
            Global.Sentry.captureException(new Error('Poool paywall fallback, no reason'));
        }

        $("#poool-widget").hide();
        $("#landing").show();
        $(".landing-box").removeClass('hidden');
    }


    PooolPaywallComponent.prototype.Paywall_ValidateForm = function (event) {
        var invalid = [];
        var fieldList = ['name', 'firstname'];
        var errorMessage = Global.LANG == 'Francais' ? 'Le champ doit être rempli' : 'This field is mandatory'
        fieldList.forEach(function (el) {
            if (event.fields[el] && event.fields[el].trim() == "")
                invalid.push({ fieldKey: el, message: errorMessage })
        })

        if (event.fields.password !== event.fields.passwordValidation) {
            var errorPasswordMessage = Global.LANG == 'Francais' ? 'Les mots de passe doivent être identiques' : 'The passwords must be identical'
            invalid.push('password');
            invalid.push({ fieldKey: 'passwordValidation', message: errorPasswordMessage });
        }

        return invalid
    }

    PooolPaywallComponent.prototype.Paywall_HandleButtonClick = function (name) {
        switch (name) {
            case 'signupModalEwallet': //A désactiver une fois Poool mis à jour
                $.Topic('signup-modal-show').publish('free', { idArticle: Global.PAYWALL_ARTICLE_ID });
                break;
            case 'signupModalFree':
                $.Topic('signup-modal-show').publish('free', { idArticle: Global.PAYWALL_ARTICLE_ID });
                break;
            case 'signinModalSimple':
                $.Topic('signin-modal-show').publish('simple', { idArticle: Global.PAYWALL_ARTICLE_ID });
                break;
            case 'buyArticle':
                $(".pme-empty, .pme-payment").removeClass('hidden');
                $(".landing-box").removeClass('hidden');
                $(".offers").addClass('hidden');
                $(".landing-title").addClass('hidden');
                $(".sous-titre-landing").addClass('hidden');
                $("hr").addClass('hidden');
                $("#poool-widget").addClass('hidden');
                break;
            default:
                return;
        }
    }

    PooolPaywallComponent.prototype.subscribeNewsletter = function (event) {
        var formData = {
            Email: event.fields.email,
            Origin: 'Article',
            UrlPage: Global.PAYWALL_USER_REDIRECT,
        };

        return $.ajaxPost('/ajax/form/newsletter', formData)
            .done(function (result) {
                Global.ajaxCallback({
                    results: result,
                    success: function (res) {
                        if (res.data.redirect != null) {
                            setTimeout(function () {
                                Global.location.replace(res.data.redirect)
                            }, 5000);
                        }
                    }
                })
            })
    }

    PooolPaywallComponent.prototype.pushDataLayer = function (nameEvent, widget, actionName) {
        var context = Global.PAYWALL_CONTEXT;
        var isPayant = Global.PAYWALL_PREMIUM_CONTENT;
        if (context == 'non-identifie') context += '-' + (isPayant == 'true' ? 'payant' : 'gratuit')

        if (Global.PAYWALL_TRIGGER != null) Global.dataLayer.push({
                event: 'pooolTriggerPaywall',
                nameAction: nameEvent,
                triggerPoool: Global.PAYWALL_TRIGGER,
                triggerValuePoool: Global.PAYWALL_TRIGGER_VALUE
            });
        else Global.dataLayer.push({
            event: 'pooolActionPaywall',
            nameEvent: nameEvent,
            contextPoool: context,
            widget: widget,
            actionName: actionName,
            segmentPoool: Global.PAYWALL_USER_SEGMENT,
            scenarioPoool: Global.PAYWALL_SCENARIO,
        });
    }

    Global.PooolPaywallComponent = PooolPaywallComponent;
} (jQuery, window));